import log from './log';
import { getSessionObject, removeSessionObject, setSessionObject } from './storage';
const enableConsentsRuntimeUpdate = () => {
    const patientMockServerUrl = window.prompt('Provide the get patient mock server URL', 'https://5a5e1010-ec3f-4c4c-becd-94d1b8020cf3.mock.pstmn.io/patient/1');
    setSessionObject('getPatient', patientMockServerUrl);
    log.info('Consents runtime update initialized');
    log.info('Refreshing the page...');
    window.location.reload();
};
const disableConsentsRuntimeUpdate = () => {
    removeSessionObject('getPatient');
    log.info('Consents runtime update disabled');
    log.info('Refreshing the page...');
    window.location.reload();
};
export const getPatientMockServerUrl = () => {
    return getSessionObject('getPatient');
};
const enableLoginAndroidIntegrityMockServer = () => {
    const loginAndroidIntegrityMockServer = window.prompt('Provide the login integrity mock server', 'https://3edec704-b202-4b13-83c5-96c4add629d1.mock.pstmn.io/v1/login');
    setSessionObject('login', loginAndroidIntegrityMockServer);
    log.info('Mock server initialized');
};
const disableLoginAndroidIntegrityMockServer = () => {
    removeSessionObject('login');
    log.info('Mock server disabled');
};
const enableRegistrationAndroidIntegrityMockServer = () => {
    const registrationAndroidIntegrityMockServer = window.prompt('Provide the registration integrity mock server', 'https://3edec704-b202-4b13-83c5-96c4add629d1.mock.pstmn.io/v1/patients');
    setSessionObject('registerPatient', registrationAndroidIntegrityMockServer);
    log.info('Mock server initialized');
};
const disableRegistrationAndroidIntegrityMockServer = () => {
    removeSessionObject('registerPatient');
    log.info('Mock server disabled');
};
window.testHelper = {
    enableConsentsRuntimeUpdate,
    disableConsentsRuntimeUpdate,
    enableLoginAndroidIntegrityMockServer,
    disableLoginAndroidIntegrityMockServer,
    enableRegistrationAndroidIntegrityMockServer,
    disableRegistrationAndroidIntegrityMockServer,
};
